import React from 'react';

// Client-side pagination for the tables that already have all their rows in
// memory. Feed it the fully-filtered row array; it hands back just the slice
// for the current page plus the props the <Pagination> control needs.
//
//   const { pageRows, pageNumber, totalRows, pageLimit, handlePageChange } =
//       usePagination(filteredRows);
//   ...
//   {pageRows.map(...)}
//   <div className='paginationContainer'>
//     <Pagination onPageChange={handlePageChange} rowsPerPage={pageLimit}
//       totalPageSize={totalRows} pageNumber={pageNumber} />
//   </div>
//
// The page number is clamped to the available range, so shrinking the result
// set (e.g. via search) never strands the view on an empty page.
const usePagination = (rows, pageLimit = 15) => {
	const [pageNumber, setPageNumber] = React.useState(1);

	const safeRows = Array.isArray(rows) ? rows : [];
	const totalRows = safeRows.length;
	const totalPages = Math.max(1, Math.ceil(totalRows / pageLimit));

	React.useEffect(() => {
		if (pageNumber > totalPages) setPageNumber(totalPages);
	}, [pageNumber, totalPages]);

	const boundedPage = Math.min(pageNumber, totalPages);
	const start = (boundedPage - 1) * pageLimit;
	const pageRows = safeRows.slice(start, start + pageLimit);

	const handlePageChange = React.useCallback((selection) => {
		setPageNumber((selection?.selected ?? 0) + 1);
	}, []);

	return { pageRows, pageNumber, setPageNumber, totalRows, pageLimit, handlePageChange };
};

export default usePagination;
